
export default {
  name: "Reviews",
  data() {
    return {
      isMessageVisible: false,
      messageTimeout: null,
    };
  },
  methods: {
    showMessage() {
      this.isMessageVisible = true;
      this.messageTimeout = setTimeout(() => {
        this.hideMessage();
      }, 3000);
    },
    hideMessage() {
      clearTimeout(this.messageTimeout);
      this.isMessageVisible = false;
    },
  },
};
